/// <amd-module name="Test/TestPlansHubRefresh/TestCasesClonePanel/Redux/TestCasesClonePanelModule" />

import { ISagaModule } from "redux-dynamic-modules-saga";
import { TestCasesClonePanelSaga } from "./TestCasesClonePanelSaga";
import { TestCasesClonePanelReducer } from "./TestCasesClonePanelReducer";
import { ITestCasesClonePanelAwareState } from "./TestCasesClonePanelContracts";
import { TestHubRefreshReducer } from "Test/TestPlansHubRefresh/TestHub/Redux/TestHubRefresh/TestHubRefreshReducer";

export const TestCasesClonePanelModule: ISagaModule<ITestCasesClonePanelAwareState> = {
    id: "testcases-clone-panel",
    reducerMap: {
        testCasesClonePanelState: TestCasesClonePanelReducer,
        testHubRefreshState: TestHubRefreshReducer
    },
    sagas: [TestCasesClonePanelSaga]
};
